
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13009',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13009",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9867",
  "foundations-components": "static-1.8320",
  "foundations-components-legacy": "static-1.1345",
  "foundations-theming": "static-1.4655",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.85",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8235",
  "hub-http-shared-msw-handlers": "static-1.10457",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11684",
  "I18n": "static-7.1651",
  "jasmine-runner": "static-1.6664",
  "marketplace-discovery-studio-lib": "static-1.470",
  "marketplace-storefront-base": "static-1.13072",
  "quartz": "static-1.7312",
  "react-dlb": "static-1.83",
  "react-rhumb": "static-1.16913",
  "reactive-variable-buffer-atom": "static-1.3065",
  "reporting-testing-lib": "static-1.10330",
  "reselect": "static-3.8",
  "settings-ui-lib": "static-1.12729",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7497",
  "ui-addon-i18n": "static-1.11357",
  "ui-addon-react-router-dom": "static-1.9743",
  "unified-auth": "static-1.743",
  "unified-auth-core-lib": "static-1.1025",
  "usage-tracker": "static-1.7562",
  "usage-tracker-core": "static-1.7412",
  "customer-data-property-utils": "static-1.8305",
  "hub-http": "static-1.6427",
  "integrations-lib": "static-1.16802",
  "marketplace-ui-common": "static-1.20438",
  "marketplace-ui-install": "static-1.424",
  "property-management-iframe": "static-1.13849",
  "quartz-config": "static-1.1090",
  "quartz-core": "static-1.6531",
  "quartz-routing": "static-1.742",
  "quick-fetch": "static-1.4063",
  "react": "static-7.189",
  "rpc-client-utils": "static-1.4869",
  "ts-schema": "static-1.4226",
  "ui-universal-auth": "static-1.9229",
  "UIComponents": "static-3.8630",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3545",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3589",
  "quartz-webpack": "static-1.3536",
  "bend-plugin-quartz-routing": "static-1.390",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4589",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5085",
  "foundations-theming-specialty": "static-1.2371",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9635",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.51",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5487",
  "react-virtualized": "static-2.102",
  "StyleGuideUI": "static-3.491",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2361",
  "ui-fonts": "static-1.946",
  "ui-images": "static-2.1215",
  "bend-plugin-foundations-theming": "static-1.3138",
  "foundations-theming-base": "static-1.3640",
  "stylex": "static-1.37",
  "HeadJS": "static-2.782",
  "hs-test-utils-bend-plugin": "static-1.3346",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4533",
  "ui-addon-video-player": "static-1.8916",
  "ai-components-ui-library": "static-1.9478",
  "ai-rendering-library": "static-1.10909",
  "chirp-fetch": "static-1.2097",
  "connections-embed-lib": "static-1.1366",
  "copilot-toolkit": "static-1.11663",
  "feedback-loader": "static-1.29672",
  "laboratory-lib": "static-3.7361",
  "marketplace-embed": "static-1.22713",
  "marketplace-ui-details": "static-1.10333",
  "marketplace-ui-reviews": "static-1.20393",
  "marketplace-ui-tracking": "static-1.14608",
  "sanitize-text": "static-1.8357",
  "usage-tracker-multi": "static-1.5976",
  "usage-tracker-session-replay": "static-1.5248",
  "wootric-nps": "static-1.7128",
  "quartz-head": "static-1.977",
  "web-vitals": "static-1.9",
  "apollo-link-hub-http": "static-2.4864",
  "immer": "static-1.33",
  "immerable": "static-1.4358",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2633",
  "reporting-data": "static-1.68397",
  "cssUtils": "static-1.855",
  "flux-actions": "static-1.355",
  "HubStyle": "static-2.11991",
  "PatternValidationJS": "static-1.3107",
  "react-colorpicker": "static-2.10419",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10575",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7552",
  "icons": "static-2.668",
  "marketplace-ui-apps-core": "static-1.18970",
  "storybook-react": "static-1.36",
  "trellis-story-utils": "static-1.4717",
  "foundations-components-test-utils": "static-1.5803",
  "quartz-i18n": "static-1.987",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.263",
  "ads-unified-auth-lib": "static-1.796",
  "google-sheets-integration-lib": "static-1.840",
  "microsoft-drive-integration-lib": "static-1.959",
  "surveymonkey-integration-lib": "static-1.284",
  "slack-ui-library": "static-1.10609",
  "fsm": "static-1.3942",
  "customer-data-objects": "static-1.7893",
  "property-translator": "static-1.5605",
  "hs-locale-management": "static-1.227",
  "frontend-preferences-client": "static-1.8136",
  "hs-promise-utils": "static-1.5803",
  "hubspot-apollo-client": "static-1.5087",
  "integrations-error-boundary-lib": "static-1.14217",
  "integrations-tracking-lib": "static-1.5817",
  "native-integrations-shared-strings": "static-1.7986",
  "sanitize": "static-1.4687",
  "superstore": "static-1.4968",
  "ui-shepherd-react": "static-3.10471",
  "ai-settings-ui-library": "static-1.8199",
  "hub-http-janus": "static-1.859",
  "hubspotter-http": "static-1.4797",
  "immutable-less": "static-1.4860",
  "marketplace-ui-client-types": "static-1.17845",
  "nav-meta": "static-1.30259",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18272",
  "ui-product-approvals-common": "static-1.798",
  "ai-studio-lib": "static-1.12246",
  "hubspot-prosemirror": "static-1.18817",
  "integrations-reconnect-lib": "static-1.339",
  "ui-addon-iframeable": "static-1.9283",
  "ui-addon-integrations-directory-panel": "static-2.8232",
  "ui-product-approvals": "static-1.28903",
  "ui-tool-access": "static-1.10362",
  "inbound-db-properties-service-client": "static-1.3991",
  "property-management-common": "static-1.6137",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.556",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.987",
  "quartz-test": "static-1.987",
  "quartz-tracking": "static-1.691",
  "trellis-components": "static-1.2380",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.279",
  "bender-build-tools": "static-1.3323",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22377",
  "ContentUtils": "static-1.68959",
  "customer-data-objects-ui-components": "static-1.13240",
  "sassPrefix": "static-1.160",
  "avatar-components": "static-1.2707",
  "breeze-engine-core": "static-1.730",
  "breeze-onboarding-components": "static-1.526",
  "customer-data-filters-ui": "static-1.40590",
  "customer-data-reference-ui-components": "static-1.13386",
  "embedded-academy-lib": "static-1.15136",
  "ExportDialog": "static-6.10587",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41823",
  "reporting-snowflake": "static-1.57015",
  "reporting-ui-components": "static-2.65668",
  "reporting-visualizations": "static-1.60473",
  "trellis-theming": "static-1.1164",
  "ui-addon-teams": "static-1.21813",
  "upgrade-components-lib": "static-1.412",
  "magpie-lib": "static-1.5699",
  "navigation-components": "static-1.18622",
  "breeze-engine-lib": "static-1.1452",
  "magpie-types": "static-1.5159",
  "simple-logging-lib": "static-1.3259",
  "fail-safe": "static-1.155",
  "app-governance-lib": "static-1.2181",
  "developer-experience-shared-components": "static-1.10707",
  "purchase-motions-components": "static-1.6229",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.9850",
  "usage-tracker-anonymous": "static-1.5979",
  "usage-tracker-public": "static-1.7373",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3911",
  "reference-resolvers": "static-1.8387",
  "ui-extensibility-client-types": "static-1.4131",
  "hubspot-apollo-cache": "static-1.546",
  "universal-page-editor-lib": "static-1.3221",
  "final-form": "static-1.73",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3355",
  "atom": "static-1.5286",
  "merchandise-lib": "static-1.269",
  "salesImages": "static-1.529",
  "codemirror": "static-5.98",
  "react-codemirror": "static-1.10850",
  "ui-addon-draggable": "static-3.4964",
  "content-assistance-lib": "static-1.8072",
  "content-media-capture": "static-1.5179",
  "customer-data-ui-utilities": "static-1.10034",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24240",
  "growth-payments-core": "static-1.25978",
  "knowledge-content-types": "static-1.8601",
  "payment-link-components": "static-1.23992",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20181",
  "ui-addon-emoji-picker": "static-1.10095",
  "ui-business-units-lib": "static-1.9290",
  "video-components-external": "static-1.11937",
  "video-data-lib": "static-1.35595",
  "navigation-messaging": "static-1.7949",
  "react-dnd-compat": "static-1.4824",
  "batch-promise": "static-1.1754",
  "crm-component-utils": "static-1.39642",
  "crm-properties-common-lib": "static-1.6097",
  "customer-data-properties": "static-1.52300",
  "external-options-client-types": "static-1.4272",
  "framework-data-schema-resolvers": "static-1.7104",
  "property-value-citations": "static-1.2914",
  "reference-resolvers-lite": "static-1.8305",
  "hubspotter-http-shared-msw-handlers": "static-1.10455",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.33",
  "cms-field-types": "static-1.5025",
  "content-icons-ui": "static-1.2291",
  "breeze-artifacts-sdk": "static-1.35",
  "onboarding-journeys-lib": "static-1.651",
  "conversations-skeleton-state": "static-1.7457",
  "crm-message-bus": "static-1.43558",
  "customer-data-filters-ui-msw-helpers": "static-1.23025",
  "events-data-lib": "static-1.448",
  "FormUrlGenerator": "static-2.4933",
  "framework-builder-read-service-client": "static-1.4152",
  "framework-data-schema-quick-fetch": "static-1.7009",
  "multi-account-reference-resolvers": "static-1.1193",
  "onboarding-tours": "static-1.16980",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14274",
  "academy-common-lib": "static-1.14596",
  "pulse": "static-1.826",
  "dashboard-lib": "static-1.82366",
  "getting-started-shared-tasks": "static-1.19012",
  "hubspot-prosemirror-plugins": "static-1.18809",
  "share-with-third-party-component-lib": "static-1.8912",
  "ui-asset-management-lib": "static-1.11297",
  "user-context": "static-1.5321",
  "reporting-plugins": "static-1.10657",
  "reporting-reports": "static-1.68075",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.932",
  "nest": "static-1.446",
  "breeze-engine-chat-components": "static-1.430",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.106",
  "framework-listing-lib": "static-2.29280",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31194",
  "apps-service-types": "static-1.3973",
  "oauth-service-types": "static-1.4463",
  "onboarding-scopes": "static-1.6668",
  "purchase-motions-api": "static-1.6232",
  "signup-constants": "static-1.19391",
  "signup-ui-url-generator": "static-2.8267",
  "onboarding-tours-client": "static-1.5194",
  "platform-infra-nav-components": "static-1.7816",
  "subscription-experience-data-types": "static-1.15161",
  "crm-record-cards-service-types": "static-1.3730",
  "location-customization-utils-lib": "static-1.9889",
  "redux-thunk": "static-2.43",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.74",
  "ui-coaching-tips": "static-1.29130",
  "content-media-composition-data-lib": "static-1.12983",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4635",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.488",
  "ui-addon-opt": "static-4.8570",
  "commerce-tours-lib": "static-1.6478",
  "growth-onboarding-reliability": "static-1.5292",
  "sales-checkout-service-client": "static-1.3743",
  "data-token-picker": "static-1.16762",
  "FileManagerLib": "static-1.39880",
  "content-media-compositions": "static-2.16990",
  "media-bridge-lib": "static-1.19278",
  "card-properties-lib": "static-1.44810",
  "commerce-subscription-lib": "static-1.37609",
  "crm-actions": "static-1.6561",
  "crm-cards-sdk": "static-1.44248",
  "customer-data-properties-shared-msw-handlers": "static-1.9784",
  "customer-data-tracking": "static-1.7094",
  "hs-resources": "static-1.390",
  "calling-global-api": "static-1.65209",
  "calling-internal-common": "static-1.31524",
  "calling-lifecycle-internal": "static-1.66591",
  "calling-lifecycle-messages": "static-1.58885",
  "commerce-products-lib": "static-1.10297",
  "conditional-properties-service-client": "static-1.3943",
  "crm-links": "static-1.6528",
  "crm-index-visualization-core": "static-1.4411",
  "crm-pipelines-api-client-types": "static-1.4282",
  "formula-editor": "static-1.14616",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4362",
  "meetings-icalendar-utils-lib": "static-1.841",
  "multi-currency-client-types": "static-1.3837",
  "object-builder-ui-client": "static-1.49412",
  "pipeline-validation-client-types": "static-1.4112",
  "smart-property-lib": "static-1.8104",
  "tiered-pricing": "static-1.1788",
  "topics-actions-lib": "static-1.365",
  "ui-addon-form-validation": "static-1.11197",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.223",
  "restore-request-side-panel-lib": "static-1.1423",
  "growth-data-modal": "static-1.5760",
  "growth-onboarding-confetti": "static-1.3270",
  "growth-onboarding-next-action-utils": "static-1.2508",
  "onboarding-tours-utils": "static-1.1046",
  "ui-shepherd-tracker": "static-1.7852",
  "academy-service-client": "static-1.3897",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39739",
  "SafeStorage": "static-1.4613",
  "video-embed": "static-1.36429",
  "bend-plugin-pulse": "static-1.329",
  "event-emitter": "static-1.1160",
  "fast-json-patch": "static-1.66",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24841",
  "viral-links-lib": "static-1.7280",
  "nested-table": "static-1.447",
  "timezone-utils": "static-2.5454",
  "getting-started-shared-tasks-store": "static-1.18130",
  "campaign-roi-lib": "static-1.9859",
  "ui-addon-calendars": "static-2.5533",
  "customer-data-views-management": "static-1.25867",
  "framework-data-table": "static-2.12375",
  "marketing-platform-lib": "static-1.7077",
  "nudge-client-utils": "static-1.3006",
  "nudge-custom-ui-functions": "static-1.1363",
  "switchboard-lib": "static-1.429",
  "app-users-service-client": "static-1.5829",
  "app-users-service-types": "static-1.5237",
  "mini-checkout-client": "static-1.27356",
  "onboarding-utils": "static-1.5571",
  "permissions-shared-i18n-strings-fe": "static-1.2099",
  "ui-coaching-tips-shared-config": "static-1.29115",
  "edison-service-client-types": "static-1.596",
  "growth-onboarding-feedback-components": "static-1.6791",
  "audio-components": "static-1.6219",
  "FileManagerImages": "static-1.37391",
  "video-components": "static-1.13939",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92627",
  "customer-data-sidebar": "static-2.46567",
  "enrichment-properties-lib": "static-1.17571",
  "ui-addon-draggable-compat": "static-2.4468",
  "universal-record-utils-lib": "static-1.1570",
  "commerce-billing-lib": "static-1.19801",
  "commerce-shared-components-lib": "static-1.19049",
  "commerce-tools-ui-lib": "static-1.10885",
  "crm-fe-perf": "static-1.23111",
  "calling-error-reporting": "static-1.31531",
  "shared-worker-versioning": "static-1.11247",
  "calling-usage-tracker": "static-1.6750",
  "voice-sms-access-library": "static-1.1735",
  "commerce-permissions": "static-1.986",
  "products-iframe-lib": "static-1.8420",
  "products-ui-components-shared-msw-handlers": "static-1.10839",
  "crm-index-associations-lib": "static-1.6651",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10540",
  "sales-views-client-types": "static-1.4466",
  "bark-lib": "static-1.16708",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.514",
  "policy-lib": "static-1.6998",
  "react-tinymce": "static-1.55790",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10603",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54916",
  "tinymce-plugins": "static-1.58030",
  "tinymce-themes": "static-1.56886",
  "onboarding-data-sync-lib": "static-1.2324",
  "growth-onboarding-next-action-components": "static-1.2536",
  "user-context-client": "static-1.4754",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4742",
  "outpost": "static-1.4374",
  "draft-convert": "static-2.76",
  "draft-extend": "static-3.79",
  "draft-js": "static-5.81",
  "draft-plugins": "static-2.22027",
  "sales-email-signature-service-client": "static-1.4053",
  "ts-utils-lib": "static-1.383",
  "crm-export-dialog": "static-1.6492",
  "crm-view-components": "static-1.899",
  "react-beautiful-dnd": "static-1.66",
  "customer-data-associations": "static-1.7542",
  "nudge-custom-function-registry": "static-1.2763",
  "nudge-renderer-utils": "static-1.3082",
  "whisper-core-api": "static-1.7132",
  "InboxConnectUtils": "static-4.15368",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.6067",
  "settings-content-modals": "static-1.46659",
  "social-insights-client-types": "static-1.22606",
  "crm_universal": "static-1.22368",
  "customer-data-email": "static-1.18397",
  "card-payment-highlight-lib": "static-1.37777",
  "card-subscription-highlight-lib": "static-1.40032",
  "commerce-contract-lib": "static-1.13001",
  "invoices-highlight-card-lib": "static-1.55403",
  "orders-highlight-card-lib": "static-1.22003",
  "products-highlight-card-lib": "static-1.18580",
  "quotes-highlight-card-lib": "static-1.72649",
  "crm-source-interpretation-lib": "static-1.5543",
  "crm-object-search-query-utilities": "static-1.10031",
  "utility-belt": "static-1.2741",
  "payments-enrollment-embed-lib": "static-1.23611",
  "stripe-embedded-components": "static-1.7867",
  "customer-data-rte": "static-1.33490",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6132",
  "payments-post-enroll-local-storage-lib": "static-1.5315",
  "qrcode-generator": "static-1.72",
  "quotes-client-types": "static-1.38739",
  "calling-orchestration-schema": "static-1.36512",
  "react-reducer-toolkit": "static-1.16173",
  "hub-http-contrib": "static-1.3251",
  "interframe": "static-3.4965",
  "tinymce-data": "static-1.41001",
  "ui-addon-sales-email": "static-1.5422",
  "layout-dnd-components": "static-1.12833",
  "layout-dnd-utils": "static-1.11808",
  "ui-brand-identity-lib": "static-1.16044",
  "NamespacedHubStyle": "static-2.9195",
  "meetings-connect-utils-lib": "static-1.7816",
  "checkout-sdk": "static-3.24199",
  "company-details-components": "static-1.6408",
  "payment-method-components": "static-1.7058",
  "pricing-pages-ui-components": "static-1.15175",
  "quote-checkout-service-types": "static-1.3662",
  "upgrade-catalog-service-types": "static-1.3700",
  "access-control-lib": "static-1.10648",
  "EmailComponents": "static-1.55367",
  "EmailData": "static-1.54045",
  "redux-less": "static-2.9691",
  "sequences-lib": "static-1.8396",
  "ui-gdpr-components": "static-1.10560",
  "products-ui-components": "static-1.40815",
  "accounting-integrations-ui-components": "static-1.7406",
  "invoices-ui-lib": "static-1.55419",
  "commerce-products-api": "static-1.2594",
  "invoices-iframe-lib": "static-1.57477",
  "quotes-modal-lib": "static-1.103327",
  "quotes-ui-lib": "static-1.81370",
  "stripe-connect-js": "static-1.73",
  "draft-content-plugins": "static-1.28758",
  "ContentData": "static-1.69034",
  "layout-data-lib": "static-1.10133",
  "hub-http-rxjs": "static-1.824",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4146",
  "billing-payments-client-types": "static-1.4199",
  "react-performance-metrics-lib": "static-1.764",
  "pricing-pages-api": "static-1.15040",
  "ContentComponents": "static-2.71915",
  "marketing-contacts-lib": "static-1.10766",
  "marketing-email-service-types": "static-1.2047",
  "messaging-editing-lib": "static-1.46940",
  "messaging-usage-based-billing-components-lib": "static-1.1802",
  "automation-ui-source-apps": "static-1.19480",
  "automation-ui-types": "static-1.20398",
  "messaging-types-lib": "static-1.46677",
  "onboarding-settings-client": "static-1.4717",
  "sequences-client-types-lib": "static-1.8253",
  "commerce-tax-lib": "static-1.747",
  "price-books-api": "static-1.1524",
  "price-books-components": "static-1.1582",
  "property-description-translator": "static-1.4049",
  "ramp-editor": "static-1.722",
  "commerce-analytics-service-client": "static-1.3731",
  "totals-ui-components": "static-1.24131",
  "SalesContentIndexUI": "static-3.9521",
  "advanced-menus-core": "static-1.15457",
  "advanced-menus-lib": "static-1.12349",
  "ui-memberships-settings-lib": "static-1.34624",
  "segments-query-core": "static-1.1631",
  "automation-ui-ubb": "static-1.6314",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7547",
  "data-token-views": "static-1.16743",
  "forms-utils-lib": "static-1.12954",
  "payments-embed-points-lib": "static-1.13447",
  "simple-menus-core": "static-1.15456",
  "simple-menus-lib": "static-1.16973",
  "videoconference-integration-components": "static-1.7121",
  "marketing-contacts-client": "static-1.7719",
  "mc-hard-limits-client-types": "static-1.111",
  "automation-applications-service-types": "static-1.3630",
  "automation-platform-service-types": "static-1.2641",
  "ContentEditorUI": "static-2.77696",
  "short-messages-app-service-client": "static-1.4128",
  "web-interactives-components": "static-1.14112",
  "web-interactives-data": "static-1.14113",
  "messaging-shared-utils-lib": "static-1.1251",
  "messaging-user-info-utils-lib": "static-1.1421",
  "email-portal-health-service-types": "static-1.1187",
  "line-items-api": "static-1.992",
  "commerce-totals-service-types": "static-1.3961",
  "FireAlarmUi": "static-1.4654",
  "sales-templates-service-types-lib": "static-1.4314",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22334",
  "automation-ui-usage-tracking": "static-1.21797",
  "data-studio-ubb": "static-1.3318",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27491",
  "collaboration-sidebar": "static-1.58508",
  "content-management-data-lib": "static-1.5805",
  "copilot-plugins": "static-1.11635",
  "cta-picker": "static-1.36917",
  "customer-agent-discovery-components-lib": "static-1.3685",
  "editor-components": "static-1.13528",
  "editor-iframe-lib": "static-1.8682",
  "error-messaging-js": "static-1.5405",
  "FormsCommonComponents": "static-1.86397",
  "pictos": "static-7.188",
  "react-transition-group": "static-2.68",
  "redux-request-state": "static-1.10856",
  "SharedLegalStrings": "static-1.1954",
  "smart-content-core": "static-1.42998",
  "smart-content-lib": "static-1.43651",
  "social-composer-lib": "static-1.59937",
  "structured-content-lib": "static-1.25738",
  "theme-previewer-lib": "static-1.53767",
  "tinymce-copilot": "static-1.16984",
  "xray-recommendation-lib": "static-1.8165",
  "automation-ui-routing": "static-1.21755",
  "sql-reporting-client-types": "static-1.5815",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42636",
  "campaigns-utils-lib": "static-1.3404",
  "reporting-enablement": "static-1.23601",
  "chatspot-widget-iframe": "static-1.22368",
  "collaboration-sidebar-common": "static-1.3305",
  "forms-ai-lib": "static-1.4631",
  "codemirror-dlb": "static-1.59255",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6645",
  "report-customization-components": "static-1.13704",
  "data-quality-ui-library": "static-1.13586",
  "reporting-filters": "static-1.832",
  "reporting-insights-lib": "static-1.2358"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13009",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9867",
  "foundations-components": "/foundations-components/static-1.8320",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1345",
  "foundations-theming": "/foundations-theming/static-1.4655",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.85",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8235",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10457",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11684",
  "I18n": "/I18n/static-7.1651",
  "jasmine-runner": "/jasmine-runner/static-1.6664",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.470",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13072",
  "quartz": "/quartz/static-1.7312",
  "react-dlb": "/react-dlb/static-1.83",
  "react-rhumb": "/react-rhumb/static-1.16913",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3065",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10330",
  "reselect": "/reselect/static-3.8",
  "settings-ui-lib": "/settings-ui-lib/static-1.12729",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7497",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11357",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9743",
  "unified-auth": "/unified-auth/static-1.743",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1025",
  "usage-tracker": "/usage-tracker/static-1.7562",
  "usage-tracker-core": "/usage-tracker-core/static-1.7412",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8305",
  "hub-http": "/hub-http/static-1.6427",
  "integrations-lib": "/integrations-lib/static-1.16802",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20438",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.424",
  "property-management-iframe": "/property-management-iframe/static-1.13849",
  "quartz-config": "/quartz-config/static-1.1090",
  "quartz-core": "/quartz-core/static-1.6531",
  "quartz-routing": "/quartz-routing/static-1.742",
  "quick-fetch": "/quick-fetch/static-1.4063",
  "react": "/react/static-7.189",
  "rpc-client-utils": "/rpc-client-utils/static-1.4869",
  "ts-schema": "/ts-schema/static-1.4226",
  "ui-universal-auth": "/ui-universal-auth/static-1.9229",
  "UIComponents": "/UIComponents/static-3.8630",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3545",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3589",
  "quartz-webpack": "/quartz-webpack/static-1.3536",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.390",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4589",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5085",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2371",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9635",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.51",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5487",
  "react-virtualized": "/react-virtualized/static-2.102",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2361",
  "ui-fonts": "/ui-fonts/static-1.946",
  "ui-images": "/ui-images/static-2.1215",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3138",
  "foundations-theming-base": "/foundations-theming-base/static-1.3640",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.782",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3346",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4533",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8916",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9478",
  "ai-rendering-library": "/ai-rendering-library/static-1.10909",
  "chirp-fetch": "/chirp-fetch/static-1.2097",
  "connections-embed-lib": "/connections-embed-lib/static-1.1366",
  "copilot-toolkit": "/copilot-toolkit/static-1.11663",
  "feedback-loader": "/feedback-loader/static-1.29672",
  "laboratory-lib": "/laboratory-lib/static-3.7361",
  "marketplace-embed": "/marketplace-embed/static-1.22713",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10333",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20393",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14608",
  "sanitize-text": "/sanitize-text/static-1.8357",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5976",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5248",
  "wootric-nps": "/wootric-nps/static-1.7128",
  "quartz-head": "/quartz-head/static-1.977",
  "web-vitals": "/web-vitals/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4864",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4358",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2633",
  "reporting-data": "/reporting-data/static-1.68397",
  "cssUtils": "/cssUtils/static-1.855",
  "flux-actions": "/flux-actions/static-1.355",
  "HubStyle": "/HubStyle/static-2.11991",
  "PatternValidationJS": "/PatternValidationJS/static-1.3107",
  "react-colorpicker": "/react-colorpicker/static-2.10419",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10575",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7552",
  "icons": "/icons/static-2.668",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18970",
  "storybook-react": "/storybook-react/static-1.36",
  "trellis-story-utils": "/trellis-story-utils/static-1.4717",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5803",
  "quartz-i18n": "/quartz-i18n/static-1.987",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.263",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.796",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.840",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.959",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.284",
  "slack-ui-library": "/slack-ui-library/static-1.10609",
  "fsm": "/fsm/static-1.3942",
  "customer-data-objects": "/customer-data-objects/static-1.7893",
  "property-translator": "/property-translator/static-1.5605",
  "hs-locale-management": "/hs-locale-management/static-1.227",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8136",
  "hs-promise-utils": "/hs-promise-utils/static-1.5803",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5087",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14217",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5817",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7986",
  "sanitize": "/sanitize/static-1.4687",
  "superstore": "/superstore/static-1.4968",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10471",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8199",
  "hub-http-janus": "/hub-http-janus/static-1.859",
  "hubspotter-http": "/hubspotter-http/static-1.4797",
  "immutable-less": "/immutable-less/static-1.4860",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17845",
  "nav-meta": "/nav-meta/static-1.30259",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18272",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.798",
  "ai-studio-lib": "/ai-studio-lib/static-1.12246",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18817",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.339",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9283",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8232",
  "ui-product-approvals": "/ui-product-approvals/static-1.28903",
  "ui-tool-access": "/ui-tool-access/static-1.10362",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3991",
  "property-management-common": "/property-management-common/static-1.6137",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.556",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.987",
  "quartz-test": "/quartz-test/static-1.987",
  "quartz-tracking": "/quartz-tracking/static-1.691",
  "trellis-components": "/trellis-components/static-1.2380",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.279",
  "bender-build-tools": "/bender-build-tools/static-1.3323",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22377",
  "ContentUtils": "/ContentUtils/static-1.68959",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13240",
  "sassPrefix": "/sassPrefix/static-1.160",
  "avatar-components": "/avatar-components/static-1.2707",
  "breeze-engine-core": "/breeze-engine-core/static-1.730",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.526",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40590",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13386",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15136",
  "ExportDialog": "/ExportDialog/static-6.10587",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41823",
  "reporting-snowflake": "/reporting-snowflake/static-1.57015",
  "reporting-ui-components": "/reporting-ui-components/static-2.65668",
  "reporting-visualizations": "/reporting-visualizations/static-1.60473",
  "trellis-theming": "/trellis-theming/static-1.1164",
  "ui-addon-teams": "/ui-addon-teams/static-1.21813",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.412",
  "magpie-lib": "/magpie-lib/static-1.5699",
  "navigation-components": "/navigation-components/static-1.18622",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1452",
  "magpie-types": "/magpie-types/static-1.5159",
  "simple-logging-lib": "/simple-logging-lib/static-1.3259",
  "fail-safe": "/fail-safe/static-1.155",
  "app-governance-lib": "/app-governance-lib/static-1.2181",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10707",
  "purchase-motions-components": "/purchase-motions-components/static-1.6229",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9850",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5979",
  "usage-tracker-public": "/usage-tracker-public/static-1.7373",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3911",
  "reference-resolvers": "/reference-resolvers/static-1.8387",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4131",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.546",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3221",
  "final-form": "/final-form/static-1.73",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3355",
  "atom": "/atom/static-1.5286",
  "merchandise-lib": "/merchandise-lib/static-1.269",
  "salesImages": "/salesImages/static-1.529",
  "codemirror": "/codemirror/static-5.98",
  "react-codemirror": "/react-codemirror/static-1.10850",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4964",
  "content-assistance-lib": "/content-assistance-lib/static-1.8072",
  "content-media-capture": "/content-media-capture/static-1.5179",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10034",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24240",
  "growth-payments-core": "/growth-payments-core/static-1.25978",
  "knowledge-content-types": "/knowledge-content-types/static-1.8601",
  "payment-link-components": "/payment-link-components/static-1.23992",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20181",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10095",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9290",
  "video-components-external": "/video-components-external/static-1.11937",
  "video-data-lib": "/video-data-lib/static-1.35595",
  "navigation-messaging": "/navigation-messaging/static-1.7949",
  "react-dnd-compat": "/react-dnd-compat/static-1.4824",
  "batch-promise": "/batch-promise/static-1.1754",
  "crm-component-utils": "/crm-component-utils/static-1.39642",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6097",
  "customer-data-properties": "/customer-data-properties/static-1.52300",
  "external-options-client-types": "/external-options-client-types/static-1.4272",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7104",
  "property-value-citations": "/property-value-citations/static-1.2914",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8305",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10455",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "cms-field-types": "/cms-field-types/static-1.5025",
  "content-icons-ui": "/content-icons-ui/static-1.2291",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.35",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.651",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7457",
  "crm-message-bus": "/crm-message-bus/static-1.43558",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23025",
  "events-data-lib": "/events-data-lib/static-1.448",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4933",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4152",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7009",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1193",
  "onboarding-tours": "/onboarding-tours/static-1.16980",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14274",
  "academy-common-lib": "/academy-common-lib/static-1.14596",
  "pulse": "/pulse/static-1.826",
  "dashboard-lib": "/dashboard-lib/static-1.82366",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19012",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18809",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8912",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11297",
  "user-context": "/user-context/static-1.5321",
  "reporting-plugins": "/reporting-plugins/static-1.10657",
  "reporting-reports": "/reporting-reports/static-1.68075",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.932",
  "nest": "/nest/static-1.446",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.430",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.106",
  "framework-listing-lib": "/framework-listing-lib/static-2.29280",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31194",
  "apps-service-types": "/apps-service-types/static-1.3973",
  "oauth-service-types": "/oauth-service-types/static-1.4463",
  "onboarding-scopes": "/onboarding-scopes/static-1.6668",
  "purchase-motions-api": "/purchase-motions-api/static-1.6232",
  "signup-constants": "/signup-constants/static-1.19391",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8267",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5194",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7816",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15161",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3730",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9889",
  "redux-thunk": "/redux-thunk/static-2.43",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29130",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12983",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4635",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.488",
  "ui-addon-opt": "/ui-addon-opt/static-4.8570",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6478",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5292",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
  "data-token-picker": "/data-token-picker/static-1.16762",
  "FileManagerLib": "/FileManagerLib/static-1.39880",
  "content-media-compositions": "/content-media-compositions/static-2.16990",
  "media-bridge-lib": "/media-bridge-lib/static-1.19278",
  "card-properties-lib": "/card-properties-lib/static-1.44810",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37609",
  "crm-actions": "/crm-actions/static-1.6561",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44248",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9784",
  "customer-data-tracking": "/customer-data-tracking/static-1.7094",
  "hs-resources": "/hs-resources/static-1.390",
  "calling-global-api": "/calling-global-api/static-1.65209",
  "calling-internal-common": "/calling-internal-common/static-1.31524",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66591",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58885",
  "commerce-products-lib": "/commerce-products-lib/static-1.10297",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3943",
  "crm-links": "/crm-links/static-1.6528",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4411",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4282",
  "formula-editor": "/formula-editor/static-1.14616",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4362",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.841",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3837",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49412",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4112",
  "smart-property-lib": "/smart-property-lib/static-1.8104",
  "tiered-pricing": "/tiered-pricing/static-1.1788",
  "topics-actions-lib": "/topics-actions-lib/static-1.365",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11197",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.223",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1423",
  "growth-data-modal": "/growth-data-modal/static-1.5760",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3270",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2508",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1046",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7852",
  "academy-service-client": "/academy-service-client/static-1.3897",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39739",
  "SafeStorage": "/SafeStorage/static-1.4613",
  "video-embed": "/video-embed/static-1.36429",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.329",
  "event-emitter": "/event-emitter/static-1.1160",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24841",
  "viral-links-lib": "/viral-links-lib/static-1.7280",
  "nested-table": "/nested-table/static-1.447",
  "timezone-utils": "/timezone-utils/static-2.5454",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18130",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9859",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5533",
  "customer-data-views-management": "/customer-data-views-management/static-1.25867",
  "framework-data-table": "/framework-data-table/static-2.12375",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7077",
  "nudge-client-utils": "/nudge-client-utils/static-1.3006",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1363",
  "switchboard-lib": "/switchboard-lib/static-1.429",
  "app-users-service-client": "/app-users-service-client/static-1.5829",
  "app-users-service-types": "/app-users-service-types/static-1.5237",
  "mini-checkout-client": "/mini-checkout-client/static-1.27356",
  "onboarding-utils": "/onboarding-utils/static-1.5571",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2099",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29115",
  "edison-service-client-types": "/edison-service-client-types/static-1.596",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6791",
  "audio-components": "/audio-components/static-1.6219",
  "FileManagerImages": "/FileManagerImages/static-1.37391",
  "video-components": "/video-components/static-1.13939",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92627",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46567",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17571",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4468",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1570",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19801",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19049",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10885",
  "crm-fe-perf": "/crm-fe-perf/static-1.23111",
  "calling-error-reporting": "/calling-error-reporting/static-1.31531",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11247",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6750",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1735",
  "commerce-permissions": "/commerce-permissions/static-1.986",
  "products-iframe-lib": "/products-iframe-lib/static-1.8420",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10839",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6651",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10540",
  "sales-views-client-types": "/sales-views-client-types/static-1.4466",
  "bark-lib": "/bark-lib/static-1.16708",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.514",
  "policy-lib": "/policy-lib/static-1.6998",
  "react-tinymce": "/react-tinymce/static-1.55790",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10603",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54916",
  "tinymce-plugins": "/tinymce-plugins/static-1.58030",
  "tinymce-themes": "/tinymce-themes/static-1.56886",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2324",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2536",
  "user-context-client": "/user-context-client/static-1.4754",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4742",
  "outpost": "/outpost/static-1.4374",
  "draft-convert": "/draft-convert/static-2.76",
  "draft-extend": "/draft-extend/static-3.79",
  "draft-js": "/draft-js/static-5.81",
  "draft-plugins": "/draft-plugins/static-2.22027",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4053",
  "ts-utils-lib": "/ts-utils-lib/static-1.383",
  "crm-export-dialog": "/crm-export-dialog/static-1.6492",
  "crm-view-components": "/crm-view-components/static-1.899",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.66",
  "customer-data-associations": "/customer-data-associations/static-1.7542",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2763",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3082",
  "whisper-core-api": "/whisper-core-api/static-1.7132",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15368",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.6067",
  "settings-content-modals": "/settings-content-modals/static-1.46659",
  "social-insights-client-types": "/social-insights-client-types/static-1.22606",
  "crm_universal": "/crm_universal/static-1.22368",
  "customer-data-email": "/customer-data-email/static-1.18397",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37777",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40032",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13001",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55403",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22003",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18580",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72649",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5543",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10031",
  "utility-belt": "/utility-belt/static-1.2741",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23611",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7867",
  "customer-data-rte": "/customer-data-rte/static-1.33490",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6132",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5315",
  "qrcode-generator": "/qrcode-generator/static-1.72",
  "quotes-client-types": "/quotes-client-types/static-1.38739",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36512",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16173",
  "hub-http-contrib": "/hub-http-contrib/static-1.3251",
  "interframe": "/interframe/static-3.4965",
  "tinymce-data": "/tinymce-data/static-1.41001",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5422",
  "layout-dnd-components": "/layout-dnd-components/static-1.12833",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11808",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16044",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9195",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7816",
  "checkout-sdk": "/checkout-sdk/static-3.24199",
  "company-details-components": "/company-details-components/static-1.6408",
  "payment-method-components": "/payment-method-components/static-1.7058",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15175",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3662",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3700",
  "access-control-lib": "/access-control-lib/static-1.10648",
  "EmailComponents": "/EmailComponents/static-1.55367",
  "EmailData": "/EmailData/static-1.54045",
  "redux-less": "/redux-less/static-2.9691",
  "sequences-lib": "/sequences-lib/static-1.8396",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10560",
  "products-ui-components": "/products-ui-components/static-1.40815",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7406",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55419",
  "commerce-products-api": "/commerce-products-api/static-1.2594",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57477",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103327",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81370",
  "stripe-connect-js": "/stripe-connect-js/static-1.73",
  "draft-content-plugins": "/draft-content-plugins/static-1.28758",
  "ContentData": "/ContentData/static-1.69034",
  "layout-data-lib": "/layout-data-lib/static-1.10133",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.824",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4146",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4199",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.764",
  "pricing-pages-api": "/pricing-pages-api/static-1.15040",
  "ContentComponents": "/ContentComponents/static-2.71915",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10766",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2047",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46940",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1802",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19480",
  "automation-ui-types": "/automation-ui-types/static-1.20398",
  "messaging-types-lib": "/messaging-types-lib/static-1.46677",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4717",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8253",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.747",
  "price-books-api": "/price-books-api/static-1.1524",
  "price-books-components": "/price-books-components/static-1.1582",
  "property-description-translator": "/property-description-translator/static-1.4049",
  "ramp-editor": "/ramp-editor/static-1.722",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3731",
  "totals-ui-components": "/totals-ui-components/static-1.24131",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9521",
  "advanced-menus-core": "/advanced-menus-core/static-1.15457",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12349",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34624",
  "segments-query-core": "/segments-query-core/static-1.1631",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6314",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7547",
  "data-token-views": "/data-token-views/static-1.16743",
  "forms-utils-lib": "/forms-utils-lib/static-1.12954",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13447",
  "simple-menus-core": "/simple-menus-core/static-1.15456",
  "simple-menus-lib": "/simple-menus-lib/static-1.16973",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7121",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7719",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.111",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3630",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2641",
  "ContentEditorUI": "/ContentEditorUI/static-2.77696",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4128",
  "web-interactives-components": "/web-interactives-components/static-1.14112",
  "web-interactives-data": "/web-interactives-data/static-1.14113",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1251",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1421",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1187",
  "line-items-api": "/line-items-api/static-1.992",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3961",
  "FireAlarmUi": "/FireAlarmUi/static-1.4654",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4314",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22334",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21797",
  "data-studio-ubb": "/data-studio-ubb/static-1.3318",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27491",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58508",
  "content-management-data-lib": "/content-management-data-lib/static-1.5805",
  "copilot-plugins": "/copilot-plugins/static-1.11635",
  "cta-picker": "/cta-picker/static-1.36917",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3685",
  "editor-components": "/editor-components/static-1.13528",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8682",
  "error-messaging-js": "/error-messaging-js/static-1.5405",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86397",
  "pictos": "/pictos/static-7.188",
  "react-transition-group": "/react-transition-group/static-2.68",
  "redux-request-state": "/redux-request-state/static-1.10856",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1954",
  "smart-content-core": "/smart-content-core/static-1.42998",
  "smart-content-lib": "/smart-content-lib/static-1.43651",
  "social-composer-lib": "/social-composer-lib/static-1.59937",
  "structured-content-lib": "/structured-content-lib/static-1.25738",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53767",
  "tinymce-copilot": "/tinymce-copilot/static-1.16984",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8165",
  "automation-ui-routing": "/automation-ui-routing/static-1.21755",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5815",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42636",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3404",
  "reporting-enablement": "/reporting-enablement/static-1.23601",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22368",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3305",
  "forms-ai-lib": "/forms-ai-lib/static-1.4631",
  "codemirror-dlb": "/codemirror-dlb/static-1.59255",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6645",
  "report-customization-components": "/report-customization-components/static-1.13704",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13586",
  "reporting-filters": "/reporting-filters/static-1.832",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2358"
}
};
